/* Project Import will be here */
import { post, IRequest } from '../index';
import { IStoreDashboardBannerModel } from 'models/storeDashboard';
/* Project Import will be here */

export const getStoreDashboardDetailApi = () => {
	const request: IRequest = {
		subUrl: '/dashboard/store',
	};
	return post(request);
};

export const getStoreDashboardBannerApi = () => {
	const request: IRequest = {
		subUrl: '/retailer/banners',
	};
	return post(request);
};

export const addStoreDashboardBannerApi = (data: IStoreDashboardBannerModel) => {
	const request: IRequest = {
		subUrl: '/retailer/AddStoreBanner',
		data,
	};
	return post(request);
};
